import { Sites } from '@ps/platform-message-framework/common/Sites';
import type { Reference, SiteHeader } from '@ps/web-martech-cms-types';
import type {
  MainNavigationBlock,
  SecondaryNavigationBlock,
  SupportNavigationBlock
} from '@ps/web-martech-cms-types/SiteHeader';
import { DismissIcon, useBodyScrollLock } from '@ps/web-shared-components';
import type { ClassNameProp } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import BrandIconButton from '../BrandIcon/BrandIconButton';
import BrandLinks from '../BrandLinks/BrandLinks';
import CMSHeaderMenu from '../CMSHeaderMenu/CMSHeaderMenu';

import styles from './Sidebar.scss';

type MobileMenuProps = {
  toggleMenu: () => void;
  menuOpen: boolean;
  main: MainNavigationBlock[];
  primary: SupportNavigationBlock[];
  secondary: SecondaryNavigationBlock[];
  brandIcon: Reference[];
  brandIconUrl?: string;
  layout?: SiteHeader['layout'];
} & Partial<ClassNameProp>;

const Sidebar: React.FC<MobileMenuProps> = ({
  menuOpen,
  toggleMenu,
  main,
  primary,
  secondary,
  brandIcon,
  brandIconUrl,
  layout
}) => {
  const site = useSelector(select.cms.getSiteId);
  const isSportsSelfExcluded = useSelector(select.account.isSportsSelfExcluded);

  const side = useRef<HTMLDivElement>(null);

  useBodyScrollLock(menuOpen, side.current);

  return (
    <>
      <div
        className={classNames(styles.sidebar, {
          [styles.sidebarOpen]: menuOpen
        })}
        ref={side}
      >
        <div className={styles.topMenu}>
          <button className={styles.closeButton} onClick={toggleMenu}>
            <DismissIcon />
          </button>
          <div className={styles.brandLogo}>
            <BrandIconButton
              brandIcon={brandIcon}
              brandIconUrl={brandIconUrl}
              onClick={toggleMenu}
              inMenu
            />
          </div>
        </div>

        <div className={styles.cmsContent}>
          {site !== Sites.NET && (
            <BrandLinks
              className={styles.brandLinks}
              main={main}
              brandsInMenu
              onClick={toggleMenu}
            />
          )}
          <CMSHeaderMenu items={primary} onClick={toggleMenu} />
          {!isSportsSelfExcluded && layout !== 'Play Money' && (
            <CMSHeaderMenu items={secondary} onClick={toggleMenu} />
          )}
        </div>
      </div>
      <div
        className={classNames(styles.overlay, {
          [styles.overlayOpen]: menuOpen
        })}
        onClick={toggleMenu}
      />
    </>
  );
};

export default Sidebar;
